import React from 'react'
import Navbar from '../components/Navbar'
import RealWordsTestComp from '../components/RealWordsTestComp'
import Footer from '../components/Footer'

function RealWordsTest() {
  return (
    <>
    <Navbar />
    <RealWordsTestComp />
    <Footer />
    </>
  )
}

export default RealWordsTest